export const SECURITY_PREFERENCES_PHONE_LABEL =
  "security-preferences-phone-label";
export const SECURITY_PREFERENCES_EMAIL_LABEL = "email-address-label";
export const EDIT_LINK = "security-preferences-edit-link";
export const REMOVE_LINK = "security-preferences-remove-link";
export const ADD_LINK = "security-preferences-add-link";
export const PHONE_NUMBER = "phone-number";
export const EMAIL_ADDRESS = "email-address";
export const PREFERRED_VERIFICATION_TOOLTIP_TEXT =
  "security-preferences-preferred-verification-tooltip-text";
export const SECURITY_PREFERENCES = "my-profile-security-preferences-label";
export const ACCOUNT_SETTINGS = "account-settings";
